module.exports = __webpack_public_path__ + "assets/cuore.320af653.svg";